module.exports = __webpack_public_path__ + "img/广州冷库 (2).f7bc65a4.jpg";